import { capitalize } from 'lodash'
import { useState } from 'react'

import DotList from 'src/shared/components/ui/dot-list'
import ImageCarousel from 'src/shared/components/ui/miscellaneous/carousel/image-carousel'
import { cn } from 'src/shared/utils/cn'
import { formatCurrency } from 'src/shared/utils/format-currency'

import type { PortfolioItem } from '../../../schemas/portfolio'
import { CoverPhotoFallback } from '../../profile-photos/cover-photo'

import PortfolioDialog from './portfolio-dialog'

type PortfolioCardProps = {
  item: PortfolioItem
  isRealtor: boolean
  className?: string
  userId: number
  username: string
}

const PortfolioCard = ({ item, isRealtor, className, userId, username }: PortfolioCardProps) => {
  const [dialogOpen, setDialogOpen] = useState(false)

  const onClick = () => {
    setDialogOpen(true)
  }

  const listingPrice = item.listingPrice ? `$${formatCurrency(item.listingPrice)}` : null
  const bedrooms = item.bedrooms ? `${item.bedrooms} beds` : null
  const bathrooms = item.bathrooms ? `${item.bathrooms} bathrooms` : null
  const squareFeet = item.squareFeet ? `${item.squareFeet} sqft` : null
  const description = [listingPrice, bedrooms, bathrooms, squareFeet] //.filter(Boolean).join(' • ')

  const shortDescription = item.description

  const pillText = item.listingStatus ? capitalize(item.listingStatus + ' listing') : null

  return (
    <>
      <button
        onClick={onClick}
        className={cn(
          'flex min-w-[250px] max-w-[calc(100vw-40px)] flex-shrink-0 flex-col gap-[15px] rounded-[20px] text-left md:min-w-[280px] md:max-w-none',
          className,
        )}
      >
        {/* <ImageGrid images={item.images} /> */}
        <div className="relative size-full min-h-[200px] overflow-hidden rounded-[20px] shadow-[0_3px_10px_1px_rgba(220,219,218,0.25)]">
          {item.images.length > 0 ? (
            <ImageCarousel images={item.images.map((image) => image.photoUrl || '')} />
          ) : (
            <img src={CoverPhotoFallback} alt={item.title} className="size-full object-cover" />
          )}
          {pillText && (
            <div className="absolute left-[17px] top-[19px] rounded-full bg-white px-[15px] py-[8px] text-[13px] font-bold shadow-[0_2px_10px_0_rgba(27,48,41,0.10)]">
              {pillText}
            </div>
          )}
        </div>
        <div className="flex flex-col gap-1">
          <div className="line-clamp-1 break-words text-[16px] font-semibold leading-[1.3] md:text-[17px]">
            {item.title}
          </div>
          <div className="line-clamp-1 break-words text-[14px] font-semibold leading-normal text-muted">
            {shortDescription}
          </div>
          {isRealtor ? (
            <DotList
              items={description}
              textClassName="text-[13px] font-semibold leading-[1.4] tracking-[-0.26px] text-primary"
              dotText="·"
            />
          ) : (
            <div className="line-clamp-2 break-words text-[13px] font-semibold leading-[1.4] tracking-[-0.26px] text-primary">
              {item.description}
            </div>
          )}
        </div>
      </button>
      <PortfolioDialog isOpen={dialogOpen} setOpen={setDialogOpen} item={item} userId={userId} username={username} />
    </>
  )
}

export default PortfolioCard
